// Open the Help drawer from anywhere: a Help button, an error message, a link in
// an article. Tiny on purpose: the kit's Alert imports it on every page.

export interface OpenHelp {
	/** Open straight at this article (an error's "Help with this"). */
	slug?: string;
}

export function openHelp(detail: OpenHelp = {}) {
	window.dispatchEvent(new CustomEvent<OpenHelp>("help:open", { detail }));
}
